import {kiln} from '@gl/kiln';
import global from '@gl/ui/global.scss?kiln';

import {Text} from './index.js';
import styles from './style.module.scss?kiln';

kiln('gl-text', {
  component: Text,
  styles: [styles, global],
  props: {
    as: {type: String},
    color: {type: String},
  },
});
